import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { class: "pagination__numbers" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = {
  key: 1,
  class: "ellipsis"
}
const _hoisted_7 = ["disabled"]

import { computed } from 'vue';
import { useStore } from "@/stores/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    pageWindowSize: { default: 7 }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const totalPages = computed(() => {
    return Math.ceil((store.searchResult?.results.length ?? 0) / store.itemsPerPage);
});

const pageWindowSize = computed(() => {
    return Math.max(props.pageWindowSize, 1);
});

const pagesToShow = computed(() => {
    const pages: number[] = [];
    const adjustedCurrentPage = store.currentPage + 1;

    if (totalPages.value <= 1) {
        return pages;
    }

    if (totalPages.value <= pageWindowSize.value + 1) {
        for (let i = 2; i < totalPages.value; i++) {
            pages.push(i);
        }

        return pages;
    }

    const halfWindow = Math.floor(pageWindowSize.value / 2);
    const maxWindowStart = totalPages.value - pageWindowSize.value;
    const windowStart = Math.min(Math.max(adjustedCurrentPage - halfWindow, 1), maxWindowStart);
    const windowEnd = windowStart + pageWindowSize.value - 1;

    for (let i = windowStart; i <= windowEnd; i++) {
        if (i !== 1 && i !== totalPages.value) {
            pages.push(i);
        }
    }

    return pages;
});

const ellipsisPresence = computed(() => {
    if (totalPages.value <= pageWindowSize.value + 1) {
        return {
            first: false,
            last: false
        }
    }

    const firstVisiblePage = pagesToShow.value[0] ?? 1;
    const lastVisiblePage = pagesToShow.value[pagesToShow.value.length - 1] ?? 1;

    return {
        first: firstVisiblePage > 2,
        last: lastVisiblePage < totalPages.value - 1
    };
});

const firstPage = () => {
    store.currentPage = 0;
};

const nextPage = () => {
    if (store.currentPage < totalPages.value - 1) {
        store.currentPage++;
    }
};

const lastPage = () => {
    store.currentPage = totalPages.value - 1;
};

const previousPage = () => {
    if (store.currentPage > 0) {
        store.currentPage--;
    }
};

const goToPage = (page: number) => {
    store.currentPage = page - 1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).currentPage !== 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--secondary next-page button--pagination",
          onClick: previousPage
        }, "‹"))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button button--secondary button--pagination",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(1))),
        disabled: _unref(store).currentPage === 0
      }, "1", 8 /* PROPS */, _hoisted_3),
      (ellipsisPresence.value.first)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagesToShow.value, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          class: "button button--secondary button--pagination",
          key: page,
          onClick: ($event: any) => (goToPage(page)),
          disabled: page === _unref(store).currentPage + 1
        }, _toDisplayString(page), 9 /* TEXT, PROPS */, _hoisted_5))
      }), 128 /* KEYED_FRAGMENT */)),
      (ellipsisPresence.value.last)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "..."))
        : _createCommentVNode("v-if", true),
      (totalPages.value > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button button--secondary button--pagination",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(totalPages.value))),
            disabled: _unref(store).currentPage + 1 === totalPages.value
          }, _toDisplayString(totalPages.value), 9 /* TEXT, PROPS */, _hoisted_7))
        : _createCommentVNode("v-if", true)
    ]),
    (_unref(store).currentPage + 1 !== totalPages.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "button button--secondary next-page button--pagination",
          onClick: nextPage
        }, "›"))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})